module.exports = __webpack_public_path__ + "img/solution_icon4.6ae18f38.png";